module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"View","anonymous":"Anonymous"},"fr":{"title":"View","anonymous":"Anonyme"},"es":{"title":"View","anonymous":"Anónimo"},"pt":{"title":"Ver","anonymous":"Anônimo"},"ar":{"title":"عرض","anonymous":"مجهول"},"sv":{"title":"Se","anonymous":"Anonymt"},"fi":{"title":"Näytä","anonymous":"Anonyymi"}}')
  delete Component.options._Ctor
}
